import { mapOperator } from './mapOperator';

// Each of these strings should map to an operator key in operatorDefinitions
export const booleanOperationList = mapOperator(['equals']);

export const campaignOperationList = mapOperator([
  'occurred',
  'neverOccurred',
  'equals',
  'doesNotEqual',
]);

export const dateOperationList = mapOperator([
  'isAfterDay',
  'isBeforeDay',
  'isOn',
  'isInYear',
]);

export const numberOperationList = mapOperator([
  'equals',
  'greaterThan',
  'lessThan',
  'isNotEqualTo',
]);

export const relativeDateOperationList = mapOperator([
  'isAfter',
  'isBefore',
  'isOnDay',
]);

export const stringOperationList = mapOperator([
  'contains',
  'doesNotContain',
  'doesNotEqual',
  'equals',
  'startsWith',
]);
